var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSharepoint(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    width: 24,
    height: 24,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:none;}.cls-2{fill:#036c70;}.cls-3{fill:#1a9ba1;}.cls-4{fill:#37c6d0;}.cls-5{opacity:0.5;}.cls-6{fill:#038387;}.cls-7{fill:#fff;}"))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Sharepoint_24x") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Sharepoint"
  }, /*#__PURE__*/React.createElement("g", {
    id: "_24",
    "data-name": 24
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    width: 24,
    height: 24
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-2",
    cx: 11,
    cy: 7,
    r: 7
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-3",
    cx: 18,
    cy: 13,
    r: 6
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 12,
    cy: 19,
    r: 5
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M13.83,6H4.07A6.63,6.63,0,0,0,4,7a7,7,0,0,0,7,7,7.59,7.59,0,0,0,1.07-.08s0,.05,0,.08H12a5,5,0,0,0-1.55.25l.42,0v0l-.64.06A5,5,0,0,0,7,19a4.71,4.71,0,0,0,.1,1h6.5A1.5,1.5,0,0,0,15,18.65V7.17A1.18,1.18,0,0,0,13.83,6Z"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Back_Plate",
    "data-name": "Back Plate",
    className: "cls-6",
    y: 5,
    width: 14,
    height: 14,
    rx: 1.17
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M5,11.85a2.37,2.37,0,0,1-.71-.74,2.08,2.08,0,0,1-.24-1,2,2,0,0,1,.45-1.32A2.69,2.69,0,0,1,5.72,8a5.2,5.2,0,0,1,1.66-.26A6.11,6.11,0,0,1,9.56,8V9.57a3.48,3.48,0,0,0-1-.41A5,5,0,0,0,7.42,9a2.43,2.43,0,0,0-1.18.26.77.77,0,0,0-.48.71.72.72,0,0,0,.2.5,1.88,1.88,0,0,0,.54.39c.23.11.56.26,1,.44l.14.06A7.87,7.87,0,0,1,8.92,12a2.24,2.24,0,0,1,.75.75,2.19,2.19,0,0,1,.27,1.14,2.18,2.18,0,0,1-.42,1.38A2.38,2.38,0,0,1,8.37,16a5.06,5.06,0,0,1-1.62.24,8.7,8.7,0,0,1-1.48-.12,5.17,5.17,0,0,1-1.2-.35V14.18a3.64,3.64,0,0,0,1.22.58A4.79,4.79,0,0,0,6.62,15a2.31,2.31,0,0,0,1.21-.26A.81.81,0,0,0,8.24,14,.78.78,0,0,0,8,13.44,2.31,2.31,0,0,0,7.38,13c-.27-.13-.66-.31-1.19-.53A6.37,6.37,0,0,1,5,11.85Z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSharepoint);
export default __webpack_public_path__ + "static/media/Sharepoint.854fa0f0824c604194bc6c6e5b94bcb7.svg";
export { ForwardRef as ReactComponent };